import { makeStyles } from '@material-ui/styles'

export default makeStyles({
  title: {
    fontSize: '20px',
    lineHeight: '28px',
    fontWeight: 500,
    color: 'black',
  },
  subtitle: {
    fontSize: '14px',
    lineHeight: '20px',
    fontWeight: 400,
    textAlign: 'center',
  },
})
